module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard-content"
  }, [_c('el-card', [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticStyle: {
      "font-size": "23px"
    }
  }, [_c('i', {
    staticClass: "fa fa-pie-chart"
  }), _vm._v("Dashboard")]), _vm._v(" "), _c('el-select', {
    staticClass: "pull-right",
    attrs: {
      "size": "small"
    },
    on: {
      "change": _vm.clusterChange
    },
    model: {
      value: (_vm.clusterKey),
      callback: function($$v) {
        _vm.clusterKey = $$v
      },
      expression: "clusterKey"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "全部集群",
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.onlineClusterkeys), function(item) {
    return _c('el-option', {
      key: item.zkClusterKey,
      attrs: {
        "label": item.zkAlias,
        "value": item.zkClusterKey
      }
    })
  })], 2)], 1), _vm._v(" "), _c('div', [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('CardPanel', {
    attrs: {
      "type": "green",
      "icon": "fa fa-life-ring",
      "title": "总域数",
      "num": _vm.domainCount,
      "to-url": "domain_statistic",
      "url-query": _vm.clusterKey
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('CardPanel', {
    attrs: {
      "type": "yellow",
      "icon": "fa fa-server",
      "title": "Executor数: 物理机+容器",
      "num": _vm.executorCount,
      "to-url": "executor_statistic",
      "url-query": _vm.clusterKey
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('CardPanel', {
    attrs: {
      "type": "primary",
      "icon": "fa fa-list-alt",
      "title": "总作业数",
      "num": _vm.jobCount,
      "to-url": "job_statistic",
      "url-query": _vm.clusterKey
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 24,
      "lg": 24,
      "xl": 12
    }
  }, [_c('Chart-container', {
    attrs: {
      "title": "历史总域数",
      "type": "line"
    }
  }, [_c('div', {
    attrs: {
      "slot": "chart"
    },
    slot: "chart"
  }, [_c('MyLine', {
    attrs: {
      "id": "domainCountHistory",
      "option-info": _vm.domainCountOptionInfo
    }
  })], 1)])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 24,
      "lg": 24,
      "xl": 12
    }
  }, [_c('Chart-container', {
    attrs: {
      "title": "历史Executor数",
      "type": "line"
    }
  }, [_c('div', {
    attrs: {
      "slot": "chart"
    },
    slot: "chart"
  }, [_c('MyLine', {
    attrs: {
      "id": "executorCountHistory",
      "option-info": _vm.executorCountOptionInfo
    }
  })], 1)])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 24,
      "lg": 24,
      "xl": 12
    }
  }, [_c('Chart-container', {
    attrs: {
      "title": "历史作业数",
      "type": "line"
    }
  }, [_c('div', {
    attrs: {
      "slot": "chart"
    },
    slot: "chart"
  }, [_c('MyLine', {
    attrs: {
      "id": "jobCountHistory",
      "option-info": _vm.jobCountOptionInfo
    }
  })], 1)])], 1)], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a3f4240a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/dashboard_manage/dashboard_manage.vue
// module id = 1435
// module chunks = 1